<template>
  <div :class="geistFontClasses">
    <a href="#main-content" class="skip-link">Skip to main content</a>
    <HeaderComponent />
    <main id="main-content">
      <RouterView />
    </main>
    <FooterComponent />
    <CookieConsent />
  </div>
</template>

<script>
import { RouterView } from "vue-router";
//import { defineComponent } from "vue";
import HeaderComponent from "./components/HeaderComponent.vue"; 
import FooterComponent from "./components/FooterComponent.vue";
import CookieConsent from "./components/CookieConsent.vue";
import "aos/dist/aos.css"; // Import AOS styles
import "@/assets/theme/styles.css";
import "./assets/fonts/GeistVF.woff"; // Geist Sans
import "./assets/fonts/GeistMonoVF.woff"; // Geist Mono


export default {
  name: 'App',
  setup() {
    // Define Geist fonts using CSS variables (if required in a global stylesheet)
    const geistFontClasses = "antialiased font-sans"; // Adjust according to your Tailwind configuration or global styles.

    return {
      geistFontClasses,
    };
  },
  components: {
    HeaderComponent,
    FooterComponent,
    CookieConsent,
    RouterView
  }
}
</script>

<style>
.skip-link {
  position: absolute;
  left: -999px;
  top: 0;
  background: var(--primary);
  color: #fff;
  padding: 0.75rem 1.25rem;
  z-index: 100000;
  border-radius: 0 0 0.25rem 0;
  font-weight: 700;
  text-decoration: none;
}
.skip-link:focus {
  left: 0;
}

@font-face {
  font-family: "Geist Sans";
  src: url("./assets/fonts/GeistVF.woff") format("woff");
  font-weight: 100 900;
}

@font-face {
  font-family: "Geist Mono";
  src: url("./assets/fonts/GeistMonoVF.woff") format("woff");
  font-weight: 100 900;
}

:root {
  --font-geist-sans: "Geist Sans", sans-serif;
  --font-geist-mono: "Geist Mono", monospace;
}

.font-sans {
  font-family: var(--font-geist-sans);
}

.font-mono {
  font-family: var(--font-geist-mono);
}
</style>
